// Packages
import eases from 'eases';

// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/new.scss';

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// FEATURES ANIMATION
//
let featuresAnimation = [];

const handleFeaturesAnimation = () => {
  const apiSuperpowerItems = document.querySelectorAll('.js-features-item');

  if (mediaSm.matches) {
    featuresAnimation.forEach((stop) => stop());
  } else {
    featuresAnimation = Array.from(
      apiSuperpowerItems,
      (apiSuperpowerItem) => {
        return scrollAnimationProgress(apiSuperpowerItem, {
          getStart(el) {
            const rect = el.getBoundingClientRect();
            return rect.top + window.scrollY - (window.innerHeight + 100);
          },
          getEnd(el, start) {
            return start + window.innerHeight * 0.66;
          },
          lerpValue: 0.25,
        });
      },
      eases.expoOut
    );
  }
};

handleFeaturesAnimation();
mediaSm.addEventListener('change', handleFeaturesAnimation);

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});
